// @flow
import Receipt from 'src/assets/icons/receipt.svg'
import Ban from 'src/assets/icons/ban.svg'
import Adelete from 'src/assets/icons/a-delete.svg'
import Multiple from 'src/assets/icons/multiple.svg'
import CreditCard from 'src/assets/icons/credit-card.svg'
import Bill from 'src/assets/icons/bill.svg'
import CalendarDate2 from 'src/assets/icons/calendar-date-2.svg'
import CalendarDate1 from 'src/assets/icons/calendar-date-1.svg'

export const numberWithCommas = (x: number) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const getContent = (weeklyPrice: number) => {
  return {
    affordabilityCheck: {
      icon: Receipt,
      label: 'Affordability check required'
    },
    noAffordabilityCheck: {
      icon: Ban,
      label: 'No affordability check required'
    },
    noGuarantor: {
      icon: Adelete,
      label: 'No Guarantor needed'
    },
    guarantor: {
      icon: Multiple,
      label: 'Qualified UK-based guarantor needed'
    },
    payUpfront: {
      icon: CreditCard,
      label: 'Pay full bill upfront (licence fee)'
    },
    payMonthly: {
      icon: Bill,
      label: 'Pay a single monthly bill (licence fee)'
    },
    rent5weeks: {
      icon: CalendarDate2,
      prelabel: 'Pay ',
      label: `£${numberWithCommas(parseInt(weeklyPrice, 10) * 5)}`,
      postlabel: '(5 weeks rent)'
    },
    rent2weeks: {
      icon: CalendarDate1,
      prelabel: 'Pay ',
      label: `£${numberWithCommas(parseInt(weeklyPrice, 10) * 2)}`,
      postlabel: '(2 weeks rent)'
    }
  }
}

export const priority = [
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'gender',
  'dob_day',
  'dob_month',
  'dob_year',
  'nationality',
  'citizenship',
  'isStudent',
  'income',
  'paymentPlan',
  'discovery',
  'terms'
]
export const getThreshold = () => {
  const underThreshold = [
    {
      plan: 'monthly_2_weeks_security_guarantor',
      id: 'with_guarantor',
      type: 'Monthly',
      icons: ['rent2weeks', 'payMonthly', 'guarantor', 'affordabilityCheck']
    },
    {
      plan: 'monthly_5_weeks_security',
      id: 'monthly_5_weeks',
      type: 'Monthly',
      icons: ['rent5weeks', 'payMonthly', 'noGuarantor', 'noAffordabilityCheck']
    },
    {
      plan: 'full_upfront_2_weeks_security',
      id: 'full_upfront',
      type: 'All upfront',
      icons: ['rent2weeks', 'payUpfront', 'noGuarantor', 'noAffordabilityCheck']
    }
  ]
  const overThreshold = [
    {
      plan: 'monthly_2_weeks_security',
      id: 'monthly_2_weeks',
      type: 'Monthly',
      icons: ['rent2weeks', 'payMonthly', 'affordabilityCheck']
    },
    {
      plan: 'monthly_5_weeks_security',
      id: 'monthly_5_weeks',
      type: 'Monthly',
      icons: ['rent5weeks', 'payMonthly', 'noAffordabilityCheck']
    },
    {
      plan: 'full_upfront_2_weeks_security',
      id: 'full_upfront',
      type: 'All upfront',
      icons: ['rent2weeks', 'payUpfront', 'noAffordabilityCheck']
    }
  ]
  return { overThreshold, underThreshold }
}



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/helpers.js